import React, { useEffect, useState } from "react";
import ashuCup from "../svgs/ashuCup2.png";
import aboutMe1 from "../svgs/aboutMe1.svg";
import SwipeableDrawer from "@material-ui/core/SwipeableDrawer";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import ArrowLeftIcon from "@material-ui/icons/ArrowLeft";
import BuildIcon from '@material-ui/icons/Build';
import SettingsIcon from '@material-ui/icons/Settings';


const useStyles = makeStyles({
  list: {
    width: 250,
  },
});

function AboutMe() {
  const classes = useStyles();
  const [state, setState] = useState(false);
  const [navAnimate, setNavAnimate] = useState(false);

  useEffect(() => {
    window.addEventListener("scroll", animateNav);
    return () => window.removeEventListener("scroll", animateNav);
  }, []);

  function animateNav() {
    if (window.scrollY > 670) {
      setNavAnimate(true);
    } else {
      setNavAnimate(false);
    }
  }
  const changeSpanColor = document.getElementById("changeSpanColor")
  const changeSpanColorPara = document.getElementById("changeSpanColorPara")
  const main__arrowIcon = document.getElementById("main__arrowIcon")
  const main__heading = document.getElementById("main__heading")

  function changeColor (){
    // document.body.style.backgroundColor = "#13858d";
    document.body.style.backgroundColor = "rgb(67, 67, 70)";
    changeSpanColor.style.color="rgb(172 179 179)"
    changeSpanColorPara.style.color="rgb(172 179 179)"
    main__heading.style.color="rgb(172 179 179)"
    main__arrowIcon.style.color="rgb(172 179 179)"
  }
  function changeColor2 (){
    document.body.style.backgroundColor = "rgb(49 62 107)";
    changeSpanColor.style.color="rgb(138 160 231)"
    changeSpanColorPara.style.color="rgb(138 160 231)"
    main__heading.style.color="rgb(138 160 231)"
    main__arrowIcon.style.color="rgb(138 160 231)"
  }
  function changeColor3 (){
    document.body.style.backgroundColor = "rgb(44 31 81)";
    changeSpanColor.style.color="rgb(139 125 175)"
    changeSpanColorPara.style.color="rgb(139 125 175)"
    main__heading.style.color="rgb(139 125 175)"
    main__arrowIcon.style.color="rgb(139 125 175)"
  }
  function changeColor4 (){
    document.body.style.backgroundColor = "rgb(68 98 111)";
    changeSpanColor.style.color="rgb(145 177 181)"
    changeSpanColorPara.style.color="rgb(145 177 181)"
    main__heading.style.color="rgb(145 177 181)"
    main__arrowIcon.style.color="rgb(145 177 181)"
  }
  function changeColor5 (){
    document.body.style.backgroundColor = "rgb(105 56 73)";
    changeSpanColor.style.color="rgb(196 157 170)"
    changeSpanColorPara.style.color="rgb(196 157 170)"
    main__heading.style.color="rgb(196 157 170)"
    main__arrowIcon.style.color="rgb(196 157 170)"
  }
  function changeColor6 (){
    document.body.style.backgroundColor = "#00608c";
    changeSpanColor.style.color="rgb(138 178 196)"
    changeSpanColorPara.style.color="rgb(138 178 196)"
    main__heading.style.color="rgb(138 178 196)"
    main__arrowIcon.style.color="rgb(138 178 196)"
  }

  const toggleDrawer = (anchor, open) => (event) => {
    setState({ [anchor]: open });
  };

  const list = (anchor) => (
    <div
      className={clsx(classes.list)}
      onClick={toggleDrawer(anchor, false)}
    ></div>
  );

  return (
    <div className="relative pt-40 flex flex-col-reverse justify-center items-center sm:justify-evenly sm:flex-row" >
      <div
        // className={`fixed top-40 opacity-0 sm:right-0 right-20 nav__zindex focus:outline-none cursor-pointer h-7 w-7 sm:h-10 sm:w-10 flex justify-center items-center rounded-sm   ${
        //   navAnimate && "bg-white opacity-100"
        // }`}
        className={`fixed top-7 opacity-0 sm:right-72 right-24 nav__zindex focus:outline-none cursor-pointer bg-[rgba(255,255,255,0.10)]   ${
          navAnimate && "bg-[#222222b7] opacity-100"
        }`}
      >
        {["right"].map((anchor) => (
          <div key={anchor}>
            <button onClick={toggleDrawer(anchor, true)}>
              <SettingsIcon className="text-gray-500 outline sm:-ml-10 animate-spin focus:outline-none" />
            </button>
            <SwipeableDrawer
              anchor={anchor}
              open={state[anchor]}
              onClose={toggleDrawer(anchor, false)}
              onOpen={toggleDrawer(anchor, true)}
            >
              {list(anchor)}
              <p className=" text-sm sm:text-base w-64 sm:w-80 text-center p-4 font-semibold relative ">Ok! Now this is the interesting part of the website, Just click on the color would you like ♥ and I will change it for u🔥</p>
              <span className=" h-5 w-5 sm:h-7 sm:w-7 bg-[#434346]  rounded-full absolute top-32 sm:top-36 mt-1 left-6 sm:left-12"></span> <p onClick={changeColor} className="text-center pt-5 border-b pb-4 cursor-pointer text-[#323E6B] font-semibold text-sm sm:text-base ">   Change Theme 🚀</p>
              
              <span className=" h-5 w-5 sm:h-7 sm:w-7 bg-[#313E6B]  rounded-full absolute top-48 sm:top-52 left-6 sm:left-12"></span> <p onClick={changeColor2} className="text-center pt-5 border-b pb-4 cursor-pointer text-[#323E6B] font-semibold text-sm sm:text-base"> Change Theme 🚀</p>
              <span className=" h-5 w-5 sm:h-7 sm:w-7 bg-[#2C1F51]  rounded-full absolute top-60 sm:top-64 mt-2 left-6 sm:left-12"></span>
              <p onClick={changeColor3} className="text-center pt-5 border-b pb-4 cursor-pointer font-semibold text-sm sm:text-base"> Change Theme 🚀</p>
              <span className=" h-5 w-5 sm:h-7 sm:w-7 bg-[#44626F]  rounded-full absolute mt-4 top-72 sm:top-80 sm:mt-2 left-6 sm:left-12"></span>
              <p onClick={changeColor4} className="text-center pt-5 border-b pb-4 cursor-pointer font-semibold text-sm sm:text-base"> Change Theme 🚀</p>
              <span className=" h-5 w-5 sm:h-7 sm:w-7 bg-[#693849]  rounded-full absolute -mt-6  top-96 sm:mt-2 left-6 sm:left-12"></span>

              <p onClick={changeColor5} className="text-center pt-5 border-b pb-4 cursor-pointer font-semibold text-sm sm:text-base"> Change Theme 🚀</p>
              <span className=" h-5 w-5 sm:h-7 sm:w-7 bg-[#8AB2C4]  rounded-full absolute -mt-7 top-[444px] sm:mt-2 left-6 sm:left-12"></span>

              <p onClick={changeColor6} className="text-center pt-5 border-b pb-4 cursor-pointer font-semibold text-sm sm:text-base"> Change Theme 🚀</p>
            </SwipeableDrawer>
          </div>
        ))}
      </div>

      <div className="relative">
        <p className="flex items-center justify-center sm:justify-start" data-aos="fade-right" data-aos-delay="700">
          About me
        </p>
        <p className="pt-6 text-2xl sm:text-4xl w-[80vw] text-center sm:text-left sm:w-[40vw] leading-loose" data-aos="fade-right" data-aos-delay="700">
          MY MISSION IS <br />

          <span className="text-blue-600 aboutMe__bottomLine" id="changeSpanColor">
            {" "}
            DESIGN & DEVELOP
          </span>{" "}
          THE BEST WEBSITES AROUND
        </p>
        <img
          src={aboutMe1}
          alt=""
          className="absolute -top-24 h-96 -left-20 opacity-20 animate-ping"
        />
        <p className="pt-10 w-[80vw] text-center sm:text-left sm:w-[43vw] leading-7 text-gray-500 aboutMe__line text-sm sm:text-base" id="changeSpanColorPara" data-aos="fade-right" data-aos-delay="700">
        I take pride in our on time delivery and ability to meet quick turn around requests while exceeding customer quality demands.To enhancing the business growth of our customers with creative Design and Development to deliver market-defining high-quality solutions .
        </p>
      </div>
      <div className="" data-aos="fade-left" data-aos-delay="700">
        <img
          src={ashuCup}
          alt=""
          loading="lazy"
          className=" h-24 rounded-full sm:rounded-none sm:h-96 object-contain opacity-80 main__arrowDown bg-[#4559850e] -mt-8 mb-10 sm:mb-0"
        />
      </div>
    </div>
  );
}

export default AboutMe;
